import Axios from '@/services/api/axios';
import IContext from '@/services/api/i-context';

interface IApiVideo {
}

export default class ApiRequest implements IApiVideo {

    public context: IContext;
    private http: Axios;

    public constructor(context: IContext) {
        this.context = context
        this.http = new Axios(context)
    }

    //获取用户登录信息
    public async getUserInfo() {
        var result = await this.http.get("/kebai-auth-sys/user/getUserInfoByUsername", {})
        return result
    }
    //获取菜单和权限
    public async getSystemMenu(username: string) {
        let result = await this.http.get("/authsys/menu/" + username, { })
        return result.data
    }
}